import React, { useEffect } from "react";

const DolphinWorldReport = () => {
  useEffect(() => {
    // Redirect to the HTML page in the public directory
    window.location.href = "/FIMTO_DolphinWorld_DailyReport_v2_2.html";
  }, []);

  return (
    <div
      style={{
        padding: "20px",
        textAlign: "center",
        minHeight: "400px",
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
      }}
    >
      <h2>Redirecting to Dolphin World Daily Report...</h2>
      <p>
        If you are not redirected automatically,{" "}
        <a href="/FIMTO_DolphinWorld_DailyReport_v2_2.html">click here</a>.
      </p>
      <div style={{ marginTop: "20px" }}>
        <div
          className="spinner"
          style={{
            border: "4px solid #f3f3f3",
            borderTop: "4px solid #3498db",
            borderRadius: "50%",
            width: "40px",
            height: "40px",
            animation: "spin 2s linear infinite",
            margin: "0 auto",
          }}
        ></div>
      </div>
      <style>{`
        @keyframes spin {
          0% { transform: rotate(0deg); }
          100% { transform: rotate(360deg); }
        }
      `}</style>
    </div>
  );
};

export default DolphinWorldReport;
